import { cn } from '@natu/utils/cn';
import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import {
  type BlokItem,
  DynamicRender,
  resolveStoryblokStyles,
  sbEditable,
  type SBProps,
  type Spacing,
} from '../../../../utils';

interface SBTableSectionProps {
  title?: string;
  subtitle?: string;
  rows: BlokItem[];
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
}

export const SBTableSection = ({ blok }: SBProps<SBTableSectionProps>) => {
  const { title, subtitle, rows, mbMobile, mbTablet, mbDesktop, mtMobile, mtTablet, mtDesktop } =
    blok;

  const className = resolveStoryblokStyles({
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
  });

  if (!isArrayWithLength(rows)) return null;

  return (
    <div className={cn(className, 'flex flex-col gap-y-10')} {...sbEditable(blok)}>
      {(title || subtitle) && (
        <div className="flex flex-col gap-y-3">
          {title && <p className="text-primary-600 text-sm font-semibold xl:text-base">{title}</p>}
          {subtitle && (
            <h2 className="text-display-sm-28 xl:text-display-md-34 font-semibold xl:w-3/4">
              {subtitle}
            </h2>
          )}
        </div>
      )}

      <div className="flex flex-col gap-y-6 lg:hidden">
        {rows.map(item => (
          <DynamicRender key={item._uid} data={item} />
        ))}
      </div>

      <div className="hidden pl-36 lg:block">
        <div className="text-naturaily-cascade grid grid-cols-[228px_1fr_1fr] text-left font-semibold">
          <div className="px-6 py-4">Step</div>
          <div className="px-10 py-4">What we do</div>
          <div className="px-10 py-4">What you get</div>
        </div>
        <div itemScope itemType="https://schema.org/HowTo">
          {rows.map(item => (
            <DynamicRender key={item._uid} data={item} />
          ))}
        </div>
      </div>
    </div>
  );
};
